module.exports = __webpack_public_path__ + "static/logo ideation.d255a8df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Curro/logo ideation.png
// module id = 55
// module chunks = 41575166079411 160870767912026 188029690210722